import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@express-labs/raven-ui';

import s from './EvergreenMessage.module.scss';
import EccBenefitsModal from '../EccBenefitsModal';

function EvergreenMessage({
  show,
  message,
  className,
  label,
  url,
  freeShippingAndReturns,
  isUserQualified,
  isEccHolderFlag,
  isModalEnable,
  orderSummaryData,
  freeShippingAndReturnsLegalCopiesData,
}) {
  const [openModal, setOpenModal] = React.useState(false);
  const closeModal = () => {
    setOpenModal(false);
  };

  const handleOnOpenModal = useCallback(() => {
    setOpenModal(true);
  }, []);

  return (
    <p className={className} data-testid="shippingPanel" aria-label="evergreen">
      {show && !!message && (
        <>
          {message}
          {isModalEnable && isEccHolderFlag && freeShippingAndReturns ? (
            <Link
              as="button"
              size="body"
              theme="dark"
              className={s.details}
              onClick={handleOnOpenModal}
            >
              {label}
            </Link>
          ) : (
            <Link
              as="a"
              theme="dark"
              size="body"
              className={s.details}
              href={url}
            >
              {label}
            </Link>
          )}
          {openModal && (
            <EccBenefitsModal
              openModal={openModal}
              closeModal={closeModal}
              isUserQualified={isUserQualified}
              orderSummaryData={orderSummaryData}
              freeShippingAndReturnsLegalCopiesData={freeShippingAndReturnsLegalCopiesData}
            />
          )}
        </>
      )}
    </p>
  );
}

EvergreenMessage.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  message: PropTypes.string,
  show: PropTypes.bool,
  url: PropTypes.string,
  freeShippingAndReturns: PropTypes.bool,
  isUserQualified: PropTypes.bool,
  isEccHolderFlag: PropTypes.bool,
  isModalEnable: PropTypes.bool,
  orderSummaryData: PropTypes.shape({}),
  freeShippingAndReturnsLegalCopiesData: PropTypes.shape({}),
};

EvergreenMessage.defaultProps = {
  className: null,
  label: null,
  message: null,
  show: true,
  url: null,
  freeShippingAndReturns: false,
  isUserQualified: false,
  isEccHolderFlag: false,
  isModalEnable: false,
  orderSummaryData: {},
  freeShippingAndReturnsLegalCopiesData: {},
};

export default EvergreenMessage;
